import { useTranslation } from "react-i18next";
import textos from "./textos/Grupos.jsx";

// Pàgina "grupos" de l'Hotel Camprodon. Els textos propis de cada idioma
// són a textos/Grupos.jsx; els genèrics, amb t() (Traducciones/lang).
// El comportament (sliders, galeria, formularis...) és a ContenidoHtml.
const Grupos = ({ lang }) => {

    const { t } = useTranslation();
    const tx = textos[lang] ?? textos.es;

    return (
        <>
            <section className="c-hero c-hero--large">
                <div className="c-hero--container" style={{maxHeight: "100vh"}}>
                    <div>
                        <div className="position-relative">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/esdeveniments__reunions-grups-esportistes__1920x1036__montana-ciclistas-eventos-grupo-deportistas-hotel-camprodon-1678106753.jpeg" alt={tx.heroImageAlt} className="image-cover image-full c-hero__image" width="100%" height="100%" />
                            </picture>
                            <div className="c-hero__content position-relative">
                                <span className="c-hero__small-title text-uppercase">{tx.heroSmallTitle}</span>
                                <h1 className="c-hero__title">{tx.heroTitle}</h1>
                                <span className="line ">
                                    <svg aria-hidden="true" focusable="false" className="c-icon ico-mouse">
                                        <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-ico-mouse-scrolldown"></use>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative bg-gray benefits-d-none benefits-d-flex-md">
                <div className="c-benefits-slider d-flex-center o-container">
                    <span className="c-benefits-slider__small-title text-uppercase">{t("Ventajas de reservar en el web oficial")}</span>
                    <ul id="draggable-slider" className="c-slider list-style-none m-0 p-0">
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__millor-preu-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Mejor precio garantizado")} />
                            </picture>
                            <div>
                                <span>{t("Mejor precio garantizado")}</span>
                            </div>
                        </li>
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__reserva-segura-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Reserva segura")} />
                            </picture>
                            <div>
                                <span>{t("Reserva segura")}</span>
                            </div>
                        </li>
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__confirmacio-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Confirmación inmediata")} />
                            </picture>
                            <div>
                                <span>{t("Confirmación inmediata")}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
            <section className="c-presentation o-container text-center ">
                <div className="c-presentation__small-title text-uppercase">{tx.presentationSmallTitle}</div>
                <h2 className="c-presentation__title">{tx.presentationTitle}</h2>
                <div className="c-presentation__content">
                    <p>{tx.presentationContent}</p>
                </div>
            </section>
            <section className="c-full-slider position-relative ">
                <div id="full-slider">
                    <div>
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/esdeveniments__reunions-grups-esportistes__1146x535__equipo-futbol-eventos-grupo-deportistas-hotel-camprodon-1678106751.jpeg" alt={tx.fullSliderImgAlt} className="image-cover c-full-slider__img" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                    </div>
                    <div>
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/esdeveniments__reunions-grups-esportistes__1146x535__equipo-baloncesto-eventos-grupo-deportistas-hotel-camprodon-1678106775.jpeg" alt={tx.fullSliderImgAlt2} className="image-cover c-full-slider__img" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                    </div>
                    <div>
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/esdeveniments__reunions-grups-esportistes__1146x535__ciclistas-montana-eventos-grupo-deportistas-hotel-camprodon-1678106754.jpeg" alt={tx.fullSliderImgAlt3} className="image-cover c-full-slider__img" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                    </div>
                </div>
                <div className="c-slider-controls-above c-slider-controls-above--bottom-right c-full-slider--index o-container">
                    <div data-slider="#full-slider" className="c-slider-controls c-slider-controls--white d-flex-center"><button className="c-slider-controls__button c-slider-controls__button--prev d-flex-center" aria-label="Previous slide">
                            <svg aria-hidden="true" focusable="false" className="c-icon ">
                                <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-arrow-slider-left"></use>
                            </svg>
                        </button>{" "}<button className="c-slider-controls__button d-flex-center" aria-label="Next slide">
                            <svg aria-hidden="true" focusable="false" className="c-icon ">
                                <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-arrow-slider-right"></use>
                            </svg>
                        </button><div className="c-slider-index"><span className="c-slider-index__item c-slider-index__item--current-index js-current-index">1</span>{" "}<span className="c-slider-index__item c-slider-index__item--total-slides js-total-slides"></span></div></div>
                </div>
            </section>
            <section className="o-container">
                <div className="summary">
                    <div className="c-section-head   c-section-head--not-default ">
                        <span className="c-section-head__subtitle text-uppercase color-primary">{tx.sectionHeadSubtitle}</span>
                        <h2 className="c-section-head__title">{tx.sectionHeadTitle}</h2>
                        <div className="c-section-head__texts">
                            {tx.sectionHeadTexts}
                        </div>
                    </div>
                </div>
            </section>
            <section className="description c-list c-list--check o-container">
                <h2 className="description--title">{tx.list}</h2>
                <p>{tx.list2}</p>
            </section>
            <section id="contact-form-section" className="c-form bg-very-light-gray">
                <div className="o-container">
                    <h2 className="c-form--title">{tx.formTitle}</h2>
                    <div className="c-form--content">{tx.formContent}</div>
                    <form id="contact-form" data-hc-form="1" action="#" method="post" className="c-form__form">
                        <input type="hidden" name="language" id="language" value={tx.languageValue} />
                        <div className="c-form__inputs">
                            <div className="c-form--element c-form--input"><input className="c-input" type="text" id="name" name="name" defaultValue="" placeholder=" " />{" "}<label className="c-label" htmlFor="name">{t("Nombre")}</label></div>
                            <div className="c-form--element c-form--input"><input className="c-input" type="email" id="email" name="email" defaultValue="" placeholder=" " />{" "}<label className="c-label" htmlFor="email">{t("Correo electrónico")}</label></div>
                        </div>
                        <div className="c-form--element"><label className="c-label" htmlFor="comments">{t("Comentarios_formulario")}</label>{" "}<textarea className="c-input" name="comments" id="comments" cols="30" rows="9" placeholder={t("Comentarios...")}></textarea></div>
                        <div className="c-form--element"></div>
                        <div className="c-form__footer d-inline-flex-md">
                            <div>
                                <div className="c-checkbox"><input type="checkbox" name="legal_checkbox" tabIndex="-1" id="legal_checkbox" />{" "}<label htmlFor="legal_checkbox">
                                        <div className="c-checkbox__square"></div>
                                        <span><span>{t("He leído y acepto las")}</span>{" "}<a href={tx.checkboxHref}>{t("Condiciones Generales y la Política de Privacidad")}</a></span>
                                    </label></div>
                            </div>
                            <input type="submit" className="c-button c-button--outline c-button--full c-form--submit c-form--submit-btn c-form--element" value={t("Enviar")} />
                        </div>
                    </form>
                </div>
            </section>
            <section className="bg-very-light-gray text-center-lg ">
                <div className="c-contact-methods d-inline-flex-md o-container">
                    <div className="c-contact-methods__item"><svg aria-hidden="true" focusable="false" className="c-icon ico-email">
                            <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-ico-email-form"></use>
                        </svg>{" "}<div className="d-inline-block">
                            <div className="title text-uppercase">{t("Por correo")}</div>
                            <span>
                                <a style={{all: "unset", cursor: "pointer"}} href="mailto:info@hotelcamprodon.com">{" info@hotelcamprodon.com "}</a>
                            </span>
                        </div></div>
                    <div className="c-contact-methods__item d-flex-center-md"><svg aria-hidden="true" focusable="false" className="c-icon ico-phone">
                            <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-ico-phone-form"></use>
                        </svg>{" "}<div className="d-inline-block">
                            <div className="title text-uppercase">{t("Por teléfono")}</div>
                            <span>
                                <a style={{all: "unset", cursor: "pointer"}} href="tel:972740013">{" 972 74 00 13 "}</a>
                            </span>
                        </div></div>
                </div>
            </section>
        </>
    );
};

export default Grupos;
